import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import cookie from "react-cookies"

import US_STATES from "shared/US_STATES.json";
import { Button, Modal, Form, Input, Select, Upload, notification, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import aiContainer from "container/AI";
import root from "window-or-global";
import TechAssets from "container/TechAssets"
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const token = process.env.REACT_APP_SECRET_ID;
const { Option } = Select;

const FormModal = ({ 
  toggleTrainingFormModal, 
  trainingFormModalResponse, 
  uploadLinkToFile,
  uploadLinkToFileResponse,
  uploadPDFToS3WithNewCloudFunction, 
  fetchComplianceTeams, 
  fetchComplianceTeamsResponse 
}) => {
  const STATE_OPTIONS = Object.keys(US_STATES).map((key) => ({
    label: US_STATES[key],
    value: US_STATES[key],
  }));
  const adminName = cookie.load("user").name

  const [form] = Form.useForm();
  const [selectedFile, setSelectedfile] = useState(null);
  const [uploadType, setUploadType] = useState(null);
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);

  // Fetch teams on mount
  useEffect(() => {
    fetchComplianceTeams();
  }, []);

  // Get teams data from response
  const teams = fetchComplianceTeamsResponse?.data || [];
  const teamsLoading = fetchComplianceTeamsResponse?.isFetching || false;
  
  // Check if document upload is in progress
  const isSubmitting = uploadLinkToFileResponse?.isFetching || false;

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 14,
      },
    },
  };

  const handleUploadType = (value) => {
    setUploadType(value)
    form.setFieldsValue({ file: null });
    form.setFieldsValue({ linkToFile: null });
  }

  const handleSubmit = async (values) => {
    const { description, file, linkToFile, state, team_id } = values || {}

    // Validate file upload
    if (!linkToFile && !uploadedFileUrl) {
      notification.error({
        message: "Error",
        description: "Please upload a file in pdf or document format",
      })
      return
    }

    // Prepare document data
    const data = {
      document_link: uploadedFileUrl || null,
      document_name: uploadedFileUrl?.split('/').pop() || null,
      document_type: "pdf",
      description: description || null,
      uploaded_by: adminName || null,      
      compliance_state: state || null,
    }

    // Add team_id only if a team is selected
    if (team_id) {
      data.team_id = team_id
    }

    if (uploadType === "uploadLinkToFile") {
      data.document_link = linkToFile || null
    } else if (uploadType === "uploadDocument") {
      data.document_link = uploadedFileUrl || null
    }

    const payload = {
      doc_info: [data],
    }

    uploadLinkToFile({
      payload,
    })
  };

  const handleCancel = () => {
    form.resetFields();
    toggleTrainingFormModal(false);
  };
  const handleRemove = () => {
    setSelectedfile(null);
  };

  const normFile = (e) => {
    return e && e.fileList;
  };

  const handleUpload = (file) => {
    setSelectedfile(file);
  };
  const handleUploadFileToS3 = async (file) => {
    console.log("REACT_APP_NODE_ENV:", process.env.REACT_APP_NODE_ENV);
    setUploadingFile(true)
    const location = "ai-training-docs"
    await uploadPDFToS3WithNewCloudFunction({
      file,
      objName: file.name,
      fileName: file.name,
      bucketName: process.env.REACT_APP_NODE_ENV === "production"  ? location : `s-${location}`,
      callback: (url) => {
        if (url?.length > 0) {
          setUploadedFileUrl(url)
          setUploadingFile(false)
        }
      },
    })
  }

  return (
    <Modal
      title="Add Documents For Training"
      visible={trainingFormModalResponse}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={handleCancel}
      okText="Submit"
    >
      <Form
        {...formItemLayout}
        variant="filled"
        style={{
          maxWidth: 600,
        }}
        onFinish={(data) => {
          handleSubmit(data);
        }}
        form={form}
      >
        <Form.Item
          label="Description:"
          name="description"
          rules={[
            {
              required: true,
              message: "Description",
            },
          ]}
        >
          <Input style={{ marginLeft: 20 }} />
        </Form.Item>
        <Form.Item
          label="Select State"
          name="state"
          rules={[
            {
              required: false,
              message: "Please input!",
            },
          ]}
        >
          <Select style={{ marginLeft: 20 }}>
            {STATE_OPTIONS.map((st) => (
              <Select.Option key={st.value} value={st.value}>
                {st.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Select Team"
          name="team_id"
          rules={[
            {
              required: false,
              message: "Please select a team",
            },
          ]}
        >
          <Select 
            placeholder="Select a team (optional)" 
            style={{ marginLeft: 20 }}
            loading={teamsLoading}
            allowClear
          >
            {teams.map((team) => (
              <Select.Option key={team.team_id} value={team.team_id}>
                {team.team_name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
          <Form.Item
            label="Upload File"
            name="file"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <Upload
              onRemove={handleRemove}
              showUploadList={{
                showRemoveIcon: true,
              }}
              beforeUpload={(file) => {
                handleUpload(file)
                handleUploadFileToS3(file)
                return false
              }}
            >
              <Button style={{ marginLeft: 20 }} icon={<UploadOutlined />}>
                Select File
              </Button>
            </Upload>
          </Form.Item>
        {/* )} */}
        <Form.Item
          wrapperCol={{
            offset: 6,
            span: 16,
          }}
        >
          <Button 
            type="primary" 
            htmlType="submit" 
            style={{ marginLeft: 70 }} 
            disabled={uploadingFile || isSubmitting} 
            loading={uploadingFile || isSubmitting}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TechAssets(aiContainer(FormModal));
